var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c('div',{staticClass:"spinner-custom"},[_c('p-progressspinner')],1):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }